import React, { createContext, useCallback, useState, useContext, useEffect } from 'react';
import { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme } from '../styles/theme'

/* Interface do Contexto */
interface ThemeAppContextData {
    isDark: boolean;
    toggleThemeApp: () => void;
}


const ThemeAppContext = createContext<ThemeAppContextData>({} as ThemeAppContextData);

const ThemeAppProvider: React.FC = ({ children }) => {
    const [isDark, setIsDark] = useState(false);

    useEffect(() => {
        if (
            !localStorage.getItem('@portalRecreativa:theme') ||
            localStorage.getItem('@portalRecreativa:theme') === 'light'
        ) {
            setIsDark(false);
        } else {
            setIsDark(true);
        }
    }, [])

    const toggleThemeApp = useCallback(() => {
        if (!isDark) {
            localStorage.setItem("@portalRecreativa:theme", "dark")
            setIsDark(true)
        } else {
            localStorage.setItem("@portalRecreativa:theme", "light")
            setIsDark(false)
        }
    }, [isDark, setIsDark]);

    return (
        <ThemeAppContext.Provider
            value={{
                isDark,
                toggleThemeApp
            }}
        >
            <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
                {children}
            </ThemeProvider>
        </ThemeAppContext.Provider>
    );
};

function useThemeApp(): ThemeAppContextData {
    const context = useContext(ThemeAppContext);

    if (!context) {
        throw new Error('useThemeApp must be used within an ThemeAppProvider');
    }
    return context;
}

export { ThemeAppProvider, useThemeApp };
